// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TableStatusCell .unit-status {\n  font-weight: 500;\n  text-transform: capitalize; }\n", ""]);
// Exports
module.exports = exports;
